<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'py-2 agent-field',
        field.error ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10' : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <div class="py-3">
        <label v-if="field.label" for="input" class="block text mb-3">
          {{ field.label }}
          <span v-if="field.required" class="text-brand-red">*</span>
        </label>
        <DropDown :options="agentOptions" :initial="initial" @select="updateValue"></DropDown>
      </div>
      <template v-if="field.help_text">
        <p class="text-brand-mid-gray italic text-xs">{{ field.help_text }}</p>
      </template>
      <template v-if="field.error">
        <p class="text-brand-red py-1">{{ errorMessage }}</p>
      </template>
    </div>
  </template>
  <template v-if="mode === 'view'"> </template>
  <template v-else-if="mode === 'form_edit'">
    <div class="flex flex-col w-full py-1">
      <DropDown disabled :options="agentOptions" placeholder="Agent Dropdown"></DropDown>
      <div class="py-2">
        <TextDisplayEditToggle
          :helpText="field.help_text"
          :type="'field_subtext'"
          @input="updateHelpText"
          :disabled="field.editable === false"
        />
      </div>
    </div>
  </template>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  emits: ["update"],
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  computed: {
    ...mapGetters(["getCurrentApplicationTemplate", "getCurrentApplication"]),
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      return true
    }
  },
  data() {
    return {
      initial: null,
      errorMessage: "",
      agentOptions: []
    }
  },
  mounted() {
    //TODO: Refactor this
    if (this.$route.params.id) {
      this.agentOptions = this.getCurrentApplication.company_agents
    } else {
      this.agentOptions = this.getCurrentApplicationTemplate.company_agents
    }

    if (this.$route.query.a) {
      const agentName = atob(this.$route.query.a).toLowerCase()
      this.initial = this.agentOptions.find((el) => el.value === agentName)
      this.updateValue(this.initial)
    } else if (this.field.value) {
      this.initial = this.agentOptions.find((el) => el.value === this.field.value)
      this.updateValue(this.initial)
    }
  },
  methods: {
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    updateValue(val) {
      this.$emit("update", val.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
